import Page from './index';

export default {
settings: {
		layout: {
			config: {
				footer:{
					display:false
				}
			}
		}
	},
	// auth: authRoles.onlyGuest,
	routes: [
		{
			path: '/shipping-locations',
			exact: true,
			component: Page.Layout
		},
	]
};